export function parseObject(id) {
    return JSON.parse(document.getElementById(id).innerHTML);
}